module.exports = __webpack_public_path__ + "img/flicker_topAB.d088617c.gif";